<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link"
                to="/AgentInfo">ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" :to="backNavigationPath">{{ this.backNavigationName
                }}</router-link>
            </li>
            <li class="breadcrumb-item router-link active">ยืนยัน OTP</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link :to="backNavigationPath">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          ยืนยันการทำรายการ
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div class="d-flex border-bottom align-items-center">
          <div class="icon-back d-none d-lg-block">
            <router-link :to="backNavigationPath">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div class="title d-none d-lg-block mx-2" style="font-family: DB Heavent; color: #0057a8">
            ยืนยันการทำรายการ
          </div>
        </div>
        <div class="card p-4 my-3">
          <label class="mb-2 font-family fs-5">ระบบส่ง OTP ไปที่ {{ this.$store.state.Otp.ISEMAIL ? "อีเมล" :
            "เบอร์มือถือ"
            }} {{
              this.$store.state.Otp.KEY
            }}</label>
          <label class="mb-2 font-family fs-5">รหัส OTP มีอายุ 5 นาที</label>
          <label class="mb-2 font-family fs-5">OTP Ref : {{ this.$store.state.Otp.REFERENCE }}</label>

          <div class="d-flex align-items-center mb-4">
            <label class="col-2 me-2 font-family fs-5">รหัส OTP :</label>
            <input v-model="Otp" type="text" maxlength="6" @keypress="isNumber($event)"
              class="field field__input a-field__input fs-6 bla-placeholder " style="border-bottom: 1px solid #d0d0d0"
              autocomplete="off" />
          </div>


          <div class="mb-2 d-flex justify-content-between">
            <button class="btn btn-primary font-family fs-5" @click="requestNewOtp" :disabled="isButtonDisabled">
              ขอรหัส OTP ใหม่ ({{ timerCount }} วินาที)
            </button>
            <button class="btn btn-success font-family fs-5" @click="confirmOtp">ยืนยัน OTP</button>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: 'CheckOTP',
  components: {
    Menu,
    LoadingBs5
  },
  data() {
    return {
      isButtonDisabled: true,
      timerCount: 61,
      Loading: false,
      backNavigationPath: this.$store.state.Otp.ISEMAIL ? "/EditEmail" : "/EditMobilePhone",
      backNavigationName: this.$store.state.Otp.ISEMAIL ? "เปลี่ยนแปลงอีเมล" : "เปลี่ยนแปลงเบอร์มือถือ",
      Otp: '',
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    requestNewOtp() {
      this.ResendOTP(this.$store.state.Otp.KEY);
      this.timerCount = 61;
      this.isButtonDisabled = true;
    },
    confirmOtp() {
      if (this.Otp !== '') {
        this.Loading = true;
        let result = this.ValidateSixDigitNumber(this.Otp);
        if (result === false) {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">รูปแบบ OTP ไม่ถูกต้องกรุณากรอกใหม่</lable>',
            confirmButtonText: 'รับทราบ' 
          }).then(() => {
            this.Otp = '';
          });

          this.Loading = false;
        }
        else {
          if (this.$store.state.Otp.ISEMAIL) { //case email
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            this.Loading = true;
            const requestBody = {
              otp: this.Otp,
              ref: this.$store.state.Otp.REFERENCE,
              mailTo: this.$store.state.Otp.KEY
            }
            http.post("AgencyERequest/VerifyEmailOTP",
              requestBody,
              { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
                this.Loading = false;
                //validate response ด้วย
                if (res.status == '200') {
                  this.$store.state.Email = this.$store.state.Otp.KEY.toUpperCase();                  
                  this.ClearData();
                  this.$router.push('/FinishEmailMobileView');

                }
                else {
                  Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการยืนยัน OTP</lable>',
                    confirmButtonText: 'รับทราบ' 
                  });
                  this.Otp = '';
                }
              }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                  icon: 'error',
                  html: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
                  confirmButtonText: 'รับทราบ' 
                });

                this.Otp = '';
              });


          }
          else { //case mobile
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            this.Loading = true;
            const requestBody = {
              otp: this.Otp,
              ref: this.$store.state.Otp.REFERENCE,
              phoneNumber: this.$store.state.Otp.KEY,
              AgentCode : this.$store.AgentCode
            }
            http.post("AgencyERequest/VerifySMSOTP",
              requestBody,
              { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
                this.Loading = false;
                if (res.status == '200') {
                  if (res.data.Successed) {
                    this.$store.state.Mobile_Phone = this.$store.state.Otp.KEY.toUpperCase();
                    this.ClearData();
                    this.$router.push('/FinishEmailMobileView');
                  }
                  else {
                  Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการยืนยัน OTP</lable>',
                    confirmButtonText: 'รับทราบ' 
                  });
                  this.Otp = '';
                }
                }
                else {
                  Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการยืนยัน OTP</lable>',
                    confirmButtonText: 'รับทราบ' 
                  });
                  this.Otp = '';
                }
              }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                  icon: 'error',
                  html: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
                  confirmButtonText: 'รับทราบ' 
                });

                this.Otp = '';
              });
          }
        }
      }
      else {
        this.Otp = '';
      }


    },
    ValidateSixDigitNumber(val) {
      let regex = /^\d{6}$/;
      return regex.test(val);
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.key;
      let re = /^\d+.?\d*$/;
      if (re.test(key)) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    ClearData() {
      this.$store.state.Otp.REFERENCE = '';
      this.$store.state.Otp.KEY = '';
      this.Otp = '';
    },
    ResendOTP(key) {
      if (this.$store.state.Otp.ISEMAIL) {
        this.ReSendEmail(key);
      }
      else {
        this.ReSendSMS(key);
      }
    },
    ReSendEmail(key) {
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      this.Loading = true;
      const requestBody = {
        email: key
      }
      http.post("AgencyERequest/SendEmailOTP",
        requestBody,
        { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          this.Loading = false;
          //validate response ด้วย
          if (res.status == '200') {
            if (res.data.processResult.Successed) {
              this.$store.state.Otp.KEY = key;
              this.$store.state.Otp.ISEMAIL = true;
              this.$store.state.Otp.REFERENCE = res.data.reference != null ? res.data.reference : null;

            }
            else {
              Swal.fire({
                icon: 'error',
                html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
                confirmButtonText: 'รับทราบ' 
              });
            }
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
              confirmButtonText: 'รับทราบ' 
            });
            this.Otp = '';
          }
        }).catch((error) => {
          this.Loading = false;
          Swal.fire({
            icon: 'error',
            html: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
            confirmButtonText: 'รับทราบ' 
          });
          this.Otp = '';
        });
    },
    ReSendSMS(key) {
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      this.Loading = true;
      const requestBody = {
        newMobileNo: key
      }
      http.post("AgencyERequest/SendSMSOTP",
        requestBody,
        { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          this.Loading = false;
          //validate response ด้วย
          if (res.status == '200') {
            this.$store.state.Otp.KEY = key;
            this.$store.state.Otp.ISEMAIL = false;
            this.$store.state.Otp.REFERENCE = res.data.reference != null ? res.data.reference : null;

          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
              confirmButtonText: 'รับทราบ' 
            });
            this.ClearData();
          }
        }).catch((error) => {
          this.Loading = false;
          console.log('error :>> ', error);
          Swal.fire({
            icon: 'error',
            html: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
            confirmButtonText: 'รับทราบ' 
          });
        });

    }

  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
        else {
          this.isButtonDisabled = false;
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    },
  }
}
</script>

<style scoped>
/* Add any component-specific styles here */
</style>